import { useEffect, useState } from 'react';
import { apiUrl } from '../../../api/apiUrl';
import http from '../../../api/axios';
import DataTable from '../../../components/table/DataTable';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/button/Button';
import { toast } from 'react-toastify';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { NumericalSeries } from '../../../types/NumericalSeries';
import { paths } from '../../RouterContainer';
import { columns } from '../../../components/columns/Company/NumericalSeriesColumns';
import { useTranslation } from '../../../context/translationContext';
import { PlusIcon } from '@heroicons/react/24/outline';
interface Props {
  companyId: number;
}
/**
 * Page component represents numerical series for current company
 */
export const NumericalSeriesPage = ({ companyId }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { company } = useCurrentCompany();
  const [numericalSeries, setNumericalSeries] = useState<NumericalSeries[] | null>(null);
  const isCurrent = window.location.pathname.includes(`current`);
  /**
   * Loads numerical series for current company
   */
  const fetchNumericalSeries = async () => {
    if (!company) return;
    const response = await http.apiGet({
      url: `${apiUrl.NUMERICAL_SERIES_LIST}?parentId=${company.id}`,
    });
    setNumericalSeries(response?.data);
  };

  useEffect(() => {
    fetchNumericalSeries();
  }, [company]);

  /**
   * Removes numberical serie
   * @param id of entity
   */
  const onRemoveItem = async (id: string | number) => {
    if (!id) return;
    const response = await http.apiDelete({
      url: `${apiUrl.NUMERICAL_SERIES_DELETE}?id=${id}`,
    });
    if (response?.status === 204) {
      toast.success('Success!');
      fetchNumericalSeries();
    }
  };

  /**
   * Redirects to numerical series edit page
   * @param id
   */
  const onEditItem = (id: string | number) => {
    if (!id) return;
    navigate(
      `/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
        paths.NUMERICAL_SERIES
      }/edit/${id}`,
    );
  };

  return (
    <>
      <div className="flex justify-end">
        <Link
          to={`/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
            paths.NUMERICAL_SERIES
          }/create`}
        >
          <Button
            title={t('general.create-new')}
            color="green"
            icon={<PlusIcon className="w-4 h-4 mr-2" />}
          />
        </Link>
      </div>
      <DataTable
        data={numericalSeries}
        columns={columns}
        handleRemove={onRemoveItem}
        handleEdit={onEditItem}
      />
    </>
  );
};
